import Loadable from 'react-loadable';
import Loading from './components/Loading';

export default [
  {
    path: '/plugin/:uuid',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Plugin'), loading: Loading })
  },
  {
    path: '/pip/:uuid',
    component: Loadable({ loader: () => import('./containers/PiP'), loading: Loading })
  }
];



// WEBPACK FOOTER //
// ./src/routes.js